import { render, staticRenderFns } from "./TotalBoardImageArticle.vue?vue&type=template&id=7a9a822a"
import script from "./TotalBoardImageArticle.ts?vue&type=script&lang=ts&external"
export * from "./TotalBoardImageArticle.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports